import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Row, Col, ListGroup, Card } from 'react-bootstrap';
import { useGetPaymentDetailsQuery } from '../slices/paymentsApiSlice';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Meta from '../components/Meta';
import PaymentCarousel from '../components/PaymentCarousel';

const PaymentScreen = () => {
  const { id: paymentId } = useParams();
  const { data: payment, isLoading, error } = useGetPaymentDetailsQuery(paymentId);

  const renderPaymentDetails = () => (
    <>
      <Meta title={payment.date} description={payment.account} />
      <Row>
        <Col md={6}>
          {/* Display payment images using PaymentCarousel */}
          {payment.images && payment.images.length > 0 ? (
            <PaymentCarousel images={payment.images} />
          ) : (
            <Message variant="info">No images available for this payment</Message>
          )}
        </Col>
        <Col md={3}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h3>{payment.accountName}</h3>
            </ListGroup.Item>
            <ListGroup.Item>Details: {payment.details}</ListGroup.Item>
            <ListGroup.Item>Amount: {payment.amount}</ListGroup.Item>
            <ListGroup.Item>
              Category: {payment.category}
            </ListGroup.Item>
            <ListGroup.Item>Notes:{payment.notes}</ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={3}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <Row>
                  <Col>Amount:</Col>
                  <Col>
                    <strong>{payment.amount}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>User:</Col>
                  <Col>
                    {payment.username}
                  </Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
          <div className="payment-images mt-3">
                    <h6>Images:</h6>
                    <div className="image-thumbnails">
                      {payment.images?.map((image, index) => (
                        <img
                          key={index}
                          src={image}
                          alt={` ${index + 1}`}
                          className="thumbnail-img"
                          style={{
                            width: '50px',
                            height: '50px',
                            marginRight: '5px',
                            borderRadius: '5px',
                          }}
                        />
                      ))}
                    </div>
                  </div>
        </Col>
      </Row>
    </>
  );

  return (
    <>
      <Link className="btn btn-light my-3" to="/">
        Go Back
      </Link>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">
          {error?.data?.message || error.error}
        </Message>
      ) : (
        renderPaymentDetails()
      )}
    </>
  );
};

export default PaymentScreen;